import { getCurrentRegion, REGION_CONFIG } from '@/config/axios.config'
import JSEncrypt from 'jsencrypt'

export const encrypt = (text) => {
  const region = JSON.parse(getCurrentRegion())

  if (!region || !region.name) {
    return null
  }

  // Per-region public key. Some hosts (e.g. Cloudflare Pages) inject env vars raw,
  // so the key arrives with literal "\n" instead of real newlines, which JSEncrypt
  // cannot parse (encrypt() returns false). env-cmd expands these locally; normalize
  // here so login encryption works in every environment.
  const pubKey = (REGION_CONFIG[region.name]?.publicKey || '').replace(
    /\\n/g,
    '\n'
  )
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pubKey)
  const encrypted = encryptor.encrypt(text)
  return encrypted
}
